<template>
<div class="tracecode">
    <div class="section">
        <div class="cate">商品信息</div>
        <div class="nr" v-if="goodsDetail">
            <div class="item">
                <div class="item_l">生产许可证</div>
                <div class="item_r">已认证</div>
            </div>
            <div class="item">
                <div class="item_l">认证单位</div>
                <div class="item_r">天津时代记忆</div>
            </div>
            <div class="item">
                <div class="item_l">认证时间</div>
                <div class="item_r">{{ goodsDetail.lasttime }}</div>
            </div>
            <div class="item">
                <div class="item_l">生产产地</div>
                <div class="item_r">{{ goodsDetail.good_place }}</div>
            </div>
            <div class="item" v-if="goodsDetail.tradesman">
                <div class="item_l">生产人员</div>
                <div class="item_r">{{ goodsDetail.tradesman.name }}</div>
            </div>
        </div>
    </div>
    <div class="section" v-if="operatLogs.length != 0">
        <div class="cate">编辑信息</div>
        <div class="nr">
            <div class="item column" v-for="item in operatLogs" :key="item.id">
                <div class="item_t">{{ item.created_at }}</div>
                <div class="item_b">
                    <span class="red">{{ item.operator_name }}</span>
					<span class="">
						<span class="" v-if="item.type == 1">进行了商品上架操作</span>
						<span class="" v-else>进行了编辑操作</span>
					</span>
                </div>
            </div>
        </div>
    </div>
    <div class="section" v-if="buyLogs.length != 0">
        <div class="cate">购买信息</div>
        <div class="nr">
            <div class="item column" v-for="item in buyLogs" :key="item.id">
                <div class="item_t">{{item.orders.pay_at}}</div>
                <div class="item_b">
                    <span class="red">{{ item.orders.person }}</span>
                    <span class="">购买了该商品</span>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import router from "../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../.././vuex/mutation_types";
import PageSearch from "../../../component/search/Index.vue";
import Vue from 'vue';
import Bridge from '../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent

export default {
    name: "my-index",
    data() {
        return {
            publicPath: process.env.BASE_URL,
            goodsDetail: null, // 商品信息
            token: null,
            goodsId: this.$route.query.goodsId, // 商品id
            operatLogs: [], // 操作记录( 新增记录 && 编辑记录 )
            buyLogs: [], // 购买记录
        };
    },
    created: function () {
        //根据userAgent判断是否在iOSAndroid客户端中
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            this.isClient = true
            var params = {
                'data': {
                    'naviTitle': '追溯码查询'
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', params, (data) => {

            })
            var memberParams = {
                'data': {
                    notCallLogin: 1,
                }
            }
            //加载用户信息
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                console.log(data)
                if (data.code == 200) {
                    this.token = data.result.token
                }
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                responseCallback('refresh success')
            })
        } else {
            this.isClient = false
            this.token = this.$store.getters.token
        }
        // 获取数据
        this.getGoodsDetail()
        this.getTraceLog()
    },
    mounted: function () {

    },
    methods: {
        // 获取商品信息
        getGoodsDetail() {
            var that = this
            var params = {
                good_id: that.goodsId
            }
            that.$api.shop.goodsDetail(params).then(res => {
                if (res.code == 200) {
                    that.goodsDetail = res.result
                }
            })
        },
        // 获取追溯信息
        getTraceLog() {
            var that = this
            var params = {
                good_id: that.goodsId
            }
            that.$api.shop.tracecode(params).then(res => {
                if (res.code == 200) {
                    var list = res.result // 总记录
                    var addArr = [] // 新增记录
					var editArr = [] // 编辑记录
                    if (list.length != 0) {
                        for (var i in list) {
                            // 1 新增 2编辑 3售出 ( 其它状态不要 4生产过程)
                            if (list[i].type == 1) {
                                addArr.push(list[i])
                            } else if (list[i].type == 2) {
                                editArr.push(list[i])
                            } else if(list[i].type == 3){
                                that.buyLogs.push(list[i])
                            }
                        }
                        // 将新增和编辑记录整合
						that.operatLogs = editArr.concat(addArr)
                    }
                }
            })
        },

    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
